const setVersion = () => {
	try {
		const scripts = Array.from(document.scripts);
		const noVersion = 'ver. unknown';
		for (const item of scripts) {
			if (item.src.includes('js/main.js') && item.src.includes(location.host)) {
				const src = item.src.split('/');
				for (const element of src) {
					if (!Number.isNaN(Number.parseFloat(element))) {
						return element;
					}
				}
			}
		}
		return noVersion;
	} catch (e) {
		console.error(e);
		// Too bad
	}
};
export const VERSION = setVersion();

const isDevelop_ = () => {
	return (
		location.href.startsWith('https://localhost') ||
		location.href.startsWith('https://sit-') ||
		location.href.startsWith('https://prep.') ||
		location.href.startsWith('https://prep-') ||
		location.href.startsWith('https://preprod-')
	);
};

const isLocalhost_ = () => {
	return location.href.startsWith('https://localhost');
};
export const isDevelop = isDevelop_();
export const isLocalHost = isLocalhost_();
